<template>
  <div v-if="forVindication">
    <span>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedInvoices.length }}</b></span><br>
    <span>{{$t('views.exsbinvoices.list.selectedSumTotalValueBrutto')}}: <b>{{ selectedSum.sumTotalValueBrutto }} {{$t('currency')}}</b></span><br>
    <span>{{$t('views.exsbinvoices.list.selectedSumTotalValueNetto')}}: <b>{{ selectedSum.sumTotalValueNetto }} {{$t('currency')}}</b></span><br>
    <span>{{$t('views.exsbinvoices.list.selectedSumToPay')}}: <b>{{ selectedSum.sumToPay }} {{$t('currency')}}</b></span><br>
  </div>
  <b-row v-else>
    <b-col>
      <router-link tag="button" :to="{ name: 'EXSBInvoiceCreate' }" class="float-right mb-1 btn btn-sm btn-primary">{{ $t('buttons.create') }} </router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
        <h6 class="card-title mt-0">{{$t('views.exsbvindicationevents.index.showSummaryData')}}</h6>
        <b-card-body>
          <span>{{$t('global.totalItems')}}: <b>{{totalItems}}</b></span><br>
          <section v-if="totalSums.length > 0 && totalSums[0].sumTotalValueBrutto !== null">
            <span>{{$t('views.exsbinvoices.list.sumTotalValueBrutto')}}: <b>{{totalSums[0].sumTotalValueBrutto}} {{$t('currency')}}</b></span><br>
            <span>{{$t('views.exsbinvoices.list.sumTotalValueNetto')}}: <b>{{totalSums[0].sumTotalValueNetto}} {{$t('currency')}}</b></span><br>
            <span>{{$t('views.exsbinvoices.list.sumToPay')}}: <b>{{ totalSums[0].sumToPay }} {{$t('currency')}}</b></span><br>
          </section>
          <hr>
          <span>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedInvoices.length }}</b></span><br>
          <span>{{$t('views.exsbinvoices.list.selectedSumTotalValueBrutto')}}: <b>{{ selectedSum.sumTotalValueBrutto }} {{$t('currency')}}</b></span><br>
          <span>{{$t('views.exsbinvoices.list.selectedSumTotalValueNetto')}}: <b>{{ selectedSum.sumTotalValueNetto }} {{$t('currency')}}</b></span><br>
          <span>{{$t('views.exsbinvoices.list.selectedSumToPay')}}: <b>{{ selectedSum.sumToPay }} {{$t('currency')}}</b></span><br>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'selectedInvoicesSum',
  props: {
    selectedInvoices: {},
    forVindication: {}
  },
  computed: {
    ...mapGetters({
      totalItems: 'exsbinvoice/list/totalItems',
      totalSums: 'exsbinvoice/list/totalSums'
    }),
    selectedSum () {
      let sumTotalValueBrutto = 0
      let sumTotalValueNetto = 0
      let sumToPay = 0
      for (let i in this.selectedInvoices) {
        sumTotalValueBrutto += this.selectedInvoices[i].totalValueBrutto
        sumTotalValueNetto += this.selectedInvoices[i].totalValueNetto
        sumToPay += this.selectedInvoices[i].toPay
      }
      return { sumTotalValueBrutto: sumTotalValueBrutto.toFixed(2), sumTotalValueNetto: sumTotalValueNetto.toFixed(2), sumToPay: sumToPay.toFixed(2) }
    }
  }
}
</script>
